"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ensureArray_1 = __importDefault(require("./utils/ensureArray"));
var omit_1 = __importDefault(require("./utils/omit"));
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var cleanupProps = function (propNames) {
    var propNamesArray = ensureArray_1.default(propNames);
    return function (props) { return omit_1.default(propNamesArray, props); };
};
exports.default = cleanupProps;
